import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

interface IProps {
  isWorking: boolean;
}

const Header: FC<IProps> = ({ isWorking }) => (
  <Grid container alignItems="flex-end" justify="space-between">
    <Grid item>
      <Typography color="inherit" variant="h4">
        <Trans i18nKey="groups:editGroup" />
      </Typography>
    </Grid>
    <Grid item>
      <Typography>
        <Trans i18nKey={isWorking ? 'common:saving' : 'common:saved'} />
      </Typography>
    </Grid>
  </Grid>
);

export default Header;
